import apiService from '../../services/ApiService';
import {useEffect, useRef} from 'react';


function useDownload() {

    /**
     * @type {React.MutableRefObject<HTMLAnchorElement>}
     */
    const saveAsLinkRef = useRef();

    // clean up on removal
    useEffect(() => {

        return () => {
            if (saveAsLinkRef.current) {
                document.body.removeChild(saveAsLinkRef.current);
            }
        };
    }, [saveAsLinkRef]);


    return async (downloadRequest, onError = () => {}) => {

        const downloadResponse = await apiService.execute(downloadRequest);
        if (downloadResponse.isErroneous()) {

            return onError();
        }

        const contentDispositionValue = downloadResponse.getHeader('Content-Disposition') || 'download';
        const filename = contentDispositionValue.replace('attachment; filename="', '')
            .replace(/"$/, '');

        const downloadData = new Blob(
            [downloadResponse.getBody()],
            {
                endings: 'transparent',
                type: downloadResponse.getHeader('Content-Type')
            }
        );

        saveAsLinkRef.current = document.createElement('a');
        saveAsLinkRef.current.href = window.URL.createObjectURL(downloadData);
        saveAsLinkRef.current.setAttribute('download', filename);
        document.body.appendChild(saveAsLinkRef.current);
        saveAsLinkRef.current.click();
    };
}


export default useDownload;
